module.exports = __webpack_public_path__ + "static/img/logo-rock.9191cf7c.svg";